import { useEffect, useState } from "react";
import { Box, Modal, TextField, Typography } from "@mui/material";
import Button from "../../../common/Button";

const AddEditModal = ({
  open,
  handleClose,
  type,
  initialData,
  isEdit,
  addMutate,
  editsMutate,
}) => {
  const [formData, setFormData] = useState({ title: "" });
  const [error, setError] = useState("");

  useEffect(() => {
    if (isEdit) {
      setFormData(initialData);
    } else {
      setFormData({ title: "" });
    }
    setError("");
  }, [isEdit, initialData, open]);

  const handleChange = (e) => {
    setFormData({ ...formData, title: e.target.value });
    setError(""); // Clear error when user starts typing
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSubmit();
    }
  };

  const handleSubmit = () => {
    if (formData.title) {
      if (isEdit) {
        editsMutate(
          { title: formData.title, id: formData.id },
          {
            onSuccess: () => {
              setFormData({ title: "" });
              handleClose();
            },
            onError: (error) => {
              if (error.response?.status === 400) {
                setError("Item already exists.");
              } else {
                setError("An error occurred. Please try again.");
              }
            },
          }
        );
      } else {
        addMutate(formData.title, {
          onSuccess: () => {
            setFormData({ title: "" });
            handleClose();
          },
          onError: (error) => {
            if (error.response?.status === 400) {
              setError("Item already exists.");
            } else {
              setError("An error occurred. Please try again.");
            }
          },
        });
      }
    }
  };

  // Capitalize the first letter of the type
  const capitalizedType = type
    ? type.charAt(0).toUpperCase() + type.slice(1)
    : "";

  return (
    <Modal open={open} onClose={handleClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: { xs: "90%", sm: 400 },
          maxHeight: "90vh",
          overflowY: "auto",
          bgcolor: "background.paper",
          boxShadow: 12,
          p: { xs: 2, sm: 4 },
          borderRadius: 2,
          textAlign: "center",
        }}
      >
        <Typography variant="h5" mb={2}>
          {isEdit ? "Edit" : "Add"} {capitalizedType}
        </Typography>

        <TextField
          fullWidth
          label="Name"
          value={formData?.title || ""}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          error={!!error}
          sx={{ mb: 2 }}
          autoFocus
        />

        {error && (
          <Typography color="error" fontSize="0.75rem" textAlign="left" mb={1}>
            {error}
          </Typography>
        )}

        <Box sx={{ display: "flex", justifyContent: "flex-end", marginTop: 2 }}>
          <Button
            onClick={handleClose}
            sx={{ marginRight: 1 }}
            backgroundColor="white"
            text="Cancel"
          />

          <Button onClick={handleSubmit} text="Save" />
        </Box>
      </Box>
    </Modal>
  );
};

export default AddEditModal;
